module.exports = {
  "source": ".subNavStickyBar__stickyBar___3DCX-{\n  height:52px;\n  width:100%; }\n.subNavStickyBar__stickyBarHide___3i7x7 .subNavStickyBar__wrapper___1njnf{\n  position:relative; }\n.subNavStickyBar__wrapper___1njnf{\n  width:100%;\n  display:-webkit-box;\n  display:-ms-flexbox;\n  display:flex;\n  -webkit-box-pack:center;\n      -ms-flex-pack:center;\n          justify-content:center;\n  position:fixed;\n  z-index:20;\n  background:#fff;\n  top:0;\n  left:0; }\n.subNavStickyBar__children___3whSE{\n  width:100%;\n  display:-webkit-box;\n  display:-ms-flexbox;\n  display:flex; }\n.subNavStickyBar__actionLeft___2n0mV,\n.subNavStickyBar__actionRight___27Sdr{\n  display:none; }\n.subNavStickyBar__actionHide___zREMA{\n  visibility:hidden; }\n",
  "classNames": {
    "stickyBar": "subNavStickyBar__stickyBar___3DCX-",
    "stickyBarHide": "subNavStickyBar__stickyBarHide___3i7x7",
    "wrapper": "subNavStickyBar__wrapper___1njnf",
    "children": "subNavStickyBar__children___3whSE",
    "actionLeft": "subNavStickyBar__actionLeft___2n0mV",
    "actionRight": "subNavStickyBar__actionRight___27Sdr",
    "actionHide": "subNavStickyBar__actionHide___zREMA"
  },
  "classNameHash": {
    "subNavStickyBar__stickyBar___3DCX-": "stickyBar",
    "subNavStickyBar__stickyBarHide___3i7x7": "stickyBarHide",
    "subNavStickyBar__wrapper___1njnf": "wrapper",
    "subNavStickyBar__children___3whSE": "children",
    "subNavStickyBar__actionLeft___2n0mV": "actionLeft",
    "subNavStickyBar__actionRight___27Sdr": "actionRight",
    "subNavStickyBar__actionHide___zREMA": "actionHide"
  }
};

module.exports.getClassName = function(name, defaultValue) {
    return module.exports.classNames[name] || defaultValue;
};

module.exports.getClassNameHash = function(name, defaultValue) {
  return module.exports.classNameHash[name] || defaultValue;
};

module.exports.toString = function() {
  return module.exports.source;
};
